/* eslint-disable no-case-declarations */
import types from './types';
import { arrayToLookup } from '../../utils/helpers';

const initialState = {
  currentIncident: null,
  fields: null,
  historyFields: null,
  resource209Fields: null,
  filters: {},
  sql: null,
  incidentListColumns: [
    'IncidentName',
    'CreatedBySystem',
    'ModifiedBySystem',
    'ModifiedOnDateTime',
    'IncidentTypeCategory'
  ],
  incidentResourceListColumns: [
    'IrwinRID',
    'GroupName',
    'CurrentDispatchUnit',
    'ResourceKind',
    'ModifiedOnDateTime'
  ],
  incidentRequestListColumns: [
    'IrwinCRID',
    'Evaluation',
    'IsValid',
    'Capacity',
    'ModifiedOnDateTime'
  ],
  incidentExperienceListColumns: ['IrwinEID', 'ModifiedOnDateTime'],
  history: {
    loading: null,
    incidents: [],
    isMore: true,
    incidentCount: 0,
    showDataGrid: false
  }
};

const incidentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_INCIDENT:
      return { ...state, currentIncident: action.payload.incident };

    case types.SET_INCIDENT_STATS:
      return { ...state, stats: action.payload.stats };

    case types.SET_INCIDENT_FIELDS:
      return { ...state, fields: action.payload.fields };

    case types.SET_INCIDENT_HISTORY_FIELDS:
      return { ...state, historyFields: action.payload.fields };

    case types.SET_INCIDENT_209_RESOURCES_FIELDS:
      return { ...state, resource209Fields: action.payload.fields };

    case types.CLEAR_INCIDENT:
      return { ...state, currentIncident: initialState.currentIncident };

    case types.SET_INITIAL_INCIDENT_FILTER:
      return { ...state, filters: action.payload.filterState };

    case types.UPDATE_INCIDENT_FILTER_VALUES:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.name]: {
            ...state.filters[action.payload.name],
            values: action.payload.values
          }
        }
      };

    case types.UPDATE_INCIDENT_SQL_FILTER:
      return { ...state, sql: action.payload.sql };

    case types.CLEAR_INCIDENT_FILTERS:
      const filtersArr = Object.keys(state.filters).map(key => {
        const filter = state.filters[key];

        return { ...filter, values: [] };
      });

      const filters = arrayToLookup(filtersArr, 'name');

      return { ...state, filters };

    // START INCIDENT COLUMNS
    case types.SET_INITIAL_INCIDENT_LIST_COLUMNS:
      const initialColumns = action.payload.columns
        ? action.payload.columns
        : initialState.incidentListColumns;

      return { ...state, incidentListColumns: initialColumns };

    case types.ADD_INCIDENT_LIST_COLUMN:
      // add an incident list column
      const addedName = action.payload.columnName;

      // and optionally provide an index position (defaults to last position if absent)
      const indexPosition =
        action.payload.indexPosition || action.payload.indexPosition === 0
          ? action.payload.indexPosition
          : state.incidentListColumns.length;

      // filter along the way to keep out any duplicate column names
      const uniqueIncidentListColumns = state.incidentListColumns.filter(
        columnName => columnName !== addedName
      );

      // add the new column at a specific place in the array
      uniqueIncidentListColumns.splice(indexPosition, 0, addedName);

      return {
        ...state,
        incidentListColumns: uniqueIncidentListColumns
      };

    case types.REMOVE_INCIDENT_LIST_COLUMN:
      // remove an incident list column
      const removedName = action.payload.columnName;
      const fewerIncidentListColumns = state.incidentListColumns.filter(
        columnName => columnName !== removedName
      );

      return {
        ...state,
        incidentListColumns: fewerIncidentListColumns
      };
    // END INCIDENT COLUMNS

    // START RESOURCE COLUMNS
    case types.SET_INITIAL_INCIDENT_RESOURCE_LIST_COLUMNS:
      const initialColumnsResource = action.payload.columns
        ? action.payload.columns
        : initialState.incidentResourceListColumns;

      return { ...state, incidentResourceListColumns: initialColumnsResource };

    case types.ADD_INCIDENT_RESOURCE_LIST_COLUMN:
      // add an incident list column
      const addedNameResource = action.payload.columnName;

      // and optionally provide an index position (defaults to last position if absent)
      const indexPositionResource =
        action.payload.indexPosition || action.payload.indexPosition === 0
          ? action.payload.indexPosition
          : state.incidentResourceListColumns.length;

      // filter along the way to keep out any duplicate column names
      const uniqueIncidentResourceListColumns = state.incidentResourceListColumns.filter(
        columnName => columnName !== addedNameResource
      );

      // add the new column at a specific place in the array
      uniqueIncidentResourceListColumns.splice(
        indexPositionResource,
        0,
        addedNameResource
      );

      return {
        ...state,
        incidentResourceListColumns: uniqueIncidentResourceListColumns
      };

    case types.REMOVE_INCIDENT_RESOURCE_LIST_COLUMN:
      // remove an incident list column
      const removedNameResource = action.payload.columnName;
      const fewerIncidentResourceListColumns = state.incidentResourceListColumns.filter(
        columnName => columnName !== removedNameResource
      );

      return {
        ...state,
        incidentResourceListColumns: fewerIncidentResourceListColumns
      };
    // END RESOURCE COLUMNS

    // START REQUEST COLUMNS
    case types.SET_INITIAL_INCIDENT_REQUEST_LIST_COLUMNS:
      const initialColumnsRequest = action.payload.columns
        ? action.payload.columns
        : initialState.incidentRequestListColumns;

      return { ...state, incidentRequestListColumns: initialColumnsRequest };

    case types.ADD_INCIDENT_REQUEST_LIST_COLUMN:
      // add an incident list column
      const addedNameRequest = action.payload.columnName;

      // and optionally provide an index position (defaults to last position if absent)
      const indexPositionRequest =
        action.payload.indexPosition || action.payload.indexPosition === 0
          ? action.payload.indexPosition
          : state.incidentRequestListColumns.length;

      // filter along the way to keep out any duplicate column names
      const uniqueIncidentRequestListColumns = state.incidentRequestListColumns.filter(
        columnName => columnName !== addedNameRequest
      );

      // add the new column at a specific place in the array
      uniqueIncidentRequestListColumns.splice(
        indexPositionRequest,
        0,
        addedNameRequest
      );

      return {
        ...state,
        incidentRequestListColumns: uniqueIncidentRequestListColumns
      };

    case types.REMOVE_INCIDENT_REQUEST_LIST_COLUMN:
      // remove an incident list column
      const removedNameRequest = action.payload.columnName;
      const fewerIncidentRequestListColumns = state.incidentRequestListColumns.filter(
        columnName => columnName !== removedNameRequest
      );

      return {
        ...state,
        incidentRequestListColumns: fewerIncidentRequestListColumns
      };
    // END REQUEST COLUMNS

    // START EXPERIENCE COLUMNS
    case types.SET_INITIAL_INCIDENT_EXPERIENCE_LIST_COLUMNS:
      const initialColumnsExperience = action.payload.columns
        ? action.payload.columns
        : initialState.incidentExperienceListColumns;

      return {
        ...state,
        incidentExperienceListColumns: initialColumnsExperience
      };

    case types.ADD_INCIDENT_EXPERIENCE_LIST_COLUMN:
      // add an incident list column
      const addedNameExperience = action.payload.columnName;

      // and optionally provide an index position (defaults to last position if absent)
      const indexPositionExperience =
        action.payload.indexPosition || action.payload.indexPosition === 0
          ? action.payload.indexPosition
          : state.incidentExperienceListColumns.length;

      // filter along the way to keep out any duplicate column names
      const uniqueIncidentExperienceListColumns = state.incidentExperienceListColumns.filter(
        columnName => columnName !== addedNameExperience
      );

      // add the new column at a specific place in the array
      uniqueIncidentExperienceListColumns.splice(
        indexPositionExperience,
        0,
        addedNameExperience
      );

      return {
        ...state,
        incidentExperienceListColumns: uniqueIncidentExperienceListColumns
      };

    case types.REMOVE_INCIDENT_EXPERIENCE_LIST_COLUMN:
      // remove an incident list column
      const removedNameExperience = action.payload.columnName;
      const fewerIncidentExperienceListColumns = state.incidentExperienceListColumns.filter(
        columnName => columnName !== removedNameExperience
      );

      return {
        ...state,
        incidentExperienceListColumns: fewerIncidentExperienceListColumns
      };
    // END EXPERIENCE COLUMNS

    case types.SET_HISTORY_LOADING:
      return {
        ...state,
        history: { ...state.history, loading: action.payload.loading }
      };

    case types.SET_HISTORY_INCIDENTS:
      return {
        ...state,
        history: { ...state.history, incidents: action.payload.incidents }
      };

    case types.SET_HISTORY_IS_MORE:
      return {
        ...state,
        history: { ...state.history, isMore: action.payload.isMore }
      };

    case types.SET_HISTORY_INCIDENT_COUNT:
      return {
        ...state,
        history: {
          ...state.history,
          incidentCount: action.payload.incidentCount
        }
      };

    case types.SET_HISTORY_SHOW_DATA_GRID:
      return {
        ...state,
        history: { ...state.history, showDataGrid: action.payload.showDataGrid }
      };

    default:
      return state;
  }
};

export default incidentReducer;



// WEBPACK FOOTER //
// ./src/redux/incident/reducers.js